export default __webpack_public_path__ + "static/kit-Nosotras-fe7a4e0b81efdc68749482ee4573a7c1.png";